<template lang="pug">
  .filter-vendor
    .filter-vendor__row(
      v-for="option,index in options"
      :key="index"
    )
      span.filter-vendor__row__title {{ $t(option.rowTitle) }}:
      span.filter-vendor__row__items
        el-select(
          v-model="selected[option.key]"
          :placeholder="$t('请选择类别')"
          size="mini"
          :disabled="shouldDisabled(option)"
          style="width: 170px"
          @change="changeSelected(option, selected[option.key])"
          @focus="handleInput(option)"
        )
          el-option(
            v-for="item,index in option.items"
            :key="index"
            :label="$t(item.name)"
            :value="item.id"
          )
    .filter-vendor__cancel
      span(@click="cancel") {{ $t("清空") }}
</template>

<script>
import axios from 'axios'

const companySize = {
  key: 'companySize',
  rowTitle: '公司规模',
  items: [
    {
      id: null,
      name: '全部'
    },
    {
      id: 1,
      name: '少于30人'
    },
    {
      id: 2,
      name: '30-50人'
    },
    {
      id: 3,
      name: '50-100人'
    },
    {
      id: 4,
      name: '100-300人'
    },
    {
      id: 5,
      name: '大于300人'
    }
  ]
}

const vendorType = {
  key: 'vendorType',
  rowTitle: '供应商类型',
  items: [
    {
      id: null,
      name: '全部'
    },
    {
      id: 1,
      name: '核心供应商'
    },
    {
      id: 2,
      name: '非核心供应商'
    },
    {
      id: 3,
      name: '非总库供应商'
    }
  ]
}

export default {
  data () {
    return {
      companySize,
      vendorType,
      category: [],
      scope: [],
      categoryTreeStructure: null,
      options: [],
      selected: {
        'category': null,
        'scope': null,
        'companySize': null,
        'vendorType': null,
        'industry': null,
        'city': null
      }
    }
  },
  mounted () {
    this.fetchOptionData()
  },
  methods: {
    shouldDisabled (item) {
      if (this.selected.category == null && item.key === 'scope') {
        return true
      } else {
        return false
      }
    },
    cancel () {
      this.selected = {
        'category': null,
        'scope': null,
        'companySize': null,
        'vendorType': null,
        'industry': null,
        'city': null
      }
      this.$emit('changeSelected', this.selected)
    },
    async fetchOptionData () {
      const [categoryList, industryList, cityList] = await Promise.all([
        this.fetchCategoryTreeStructure(),
        this.fetchIndustryList(),
        this.fetchCityList()
      ])
      this.categoryTreeStructure = categoryList

      const category = {
        key: 'category',
        rowTitle: '服务类别',
        items: [
          {
            id: null,
            name: '全部'
          },
          ...this.categoryTreeStructure.map(c => {
            return {
              id: c.category_id,
              name: c.category_name
            }
          })
        ]
      }

      const scope = {
        key: 'scope',
        rowTitle: '服务范围',
        items: this.getScopeItems(null)
      }

      const city = {
        key: 'city',
        rowTitle: '所在城市',
        items: [
          {
            id: null,
            name: '全部'
          },
          ...cityList.map(c => {
            return {
              id: c.city,
              name: c.city
            }
          })
        ]
      }

      const industry = {
        key: 'industry',
        rowTitle: '服务行业',
        items: [
          {
            id: null,
            name: '全部'
          },
          ...industryList.map(c => {
            return {
              id: c.industry_id,
              name: c.industry_name
            }
          })
        ]
      }

      this.options.push(category, scope, industry, this.vendorType, this.companySize, city)
    },
    fetchCityList () {
      return axios
        .get('/common/getCityListByCompany')
    },
    fetchIndustryList () {
      return axios
        .get('/common/getIndustryListByCompany', {
          params: {
            category_id: this.selected.category
          }
        })
    },
    fetchCategoryTreeStructure () {
      return axios
        .get('/common/getCategoryTreeStructure')
    },
    getScopeItems (categoryId) {
      let scopeItems = []
      let sourceScopeItems = []
      if (categoryId == null) {
        this.categoryTreeStructure.forEach(c => {
          c.children.forEach(s => {
            sourceScopeItems.push({
              id: s.scope_id,
              name: s.scope_name
            })
          })
        })
      } else {
        this.categoryTreeStructure.find(c => c.category_id === categoryId).children.forEach(s => {
          sourceScopeItems.push({
            id: s.scope_id,
            name: s.scope_name
          })
        })
      }
      scopeItems = [
        {
          id: null,
          name: '全部'
        },
        ...sourceScopeItems
      ]
      return scopeItems
    },
    changeSelected (option, id) {
      this.selected[option.key] = id
      if (option.key === 'category') {
        this.options.find(o => o.key === 'scope').items = this.getScopeItems(this.selected['category'])
        this.selected['scope'] = null
      }
      this.$emit('changeSelected', this.selected)
    },
    async handleInput (option) {
      if (option.key === 'industry') {
        const industryList = await this.fetchIndustryList()
        this.options.forEach(i => {
          if (i.key === 'industry') {
            i.items = [
              {
                id: null,
                name: '全部'
              },
              ...industryList.map(c => {
                return {
                  id: c.industry_id,
                  name: c.industry_name
                }
              })
            ]
          }
        })
      }
    }
  }
}
</script>

<style lang="stylus">
.filter-vendor
  background #fff
  padding 20px 0
  font-size 12px
  display flex
  padding 24px 32px
  border-top 1px solid #e8e8e8
  border-bottom 1px solid #e8e8e8
  align-items flex-end
  flex-wrap wrap
  align-items center

.filter-vendor__row
  display: flex
  flex-direction: column
  margin-right 24px

.filter-vendor__row__title
  color #8c8c8c

.filter-vendor__row__items
  margin-top 8px
  display inline-block
  margin-bottom 16px

.filter-vendor__row:last-child
  margin-bottom 0

.filter-vendor__row__title
  display inline-block
  min-width 85px
  text-align left

.filter-vendor__row__item
  display inline-block
  padding 5px
  cursor pointer
  &.active
    border-radius 2px
    border solid 1px #5f99f6
    background-color #edf2fa
    color $main

.filter-vendor__cancel
  height 28px
  display flex
  align-items center
  > span
    cursor pointer
    color $main
    height 24px
    line-height 28px
</style>
